<template>
    <div class="content-wrapper">
        <div class="row">
            <app-breadcrumb :page-title="sport" :directory="$t('datatables')" :icon="'grid'" class="col-6"/>
        </div>  
        <div class="mb-primary col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <h5 class="mb-3 d-none">{{ $t('filters') }}</h5>
        
            <app-table
                :id="'sports-filter-table'"
                :options="options"
                @action="getAction"
            />
            <!--large modal start-->
            <app-modal v-if="createAlertModal"
                        modal-id="create-alert-modal"
                        modal-alignment="center"
                        modal-size="large"
                        @confirmed="saveCreateAlert"
                        @close-modal="closeModal">
                <template slot="header">
                    <div>
                        <h5 class="modal-title">{{ selectedRow.name }}</h5>
                        <h6>{{ selectedRow.sport }}</h6>
                    </div>
                    <button type="button" class="close outline-none" data-dismiss="modal" aria-label="Close">
                        <span>
                            <app-icon :name="'x'"></app-icon>
                        </span>
                    </button>
                </template>
                <template slot="body">
                    <form id="create-alert">
                        <div>
                            <div class="d-flex justify-content-center pb-2">{{ $t('wdw') }}</div>
                            <div class="d-flex flex-column flex-md-row">
                                <div class="col-12 col-md-3">
                                    <label for="wdw_1">
                                        {{ $t('home') }}
                                    </label>
                                    <div>
                                        <input
                                            type="number" 
                                            step="any"
                                            id="wdw_1"
                                            name="wdw[1]"
                                            v-model="selectedConditions['wdw']['1']"
                                            class="form-control"
                                            :placeholder="$t('min_odds')"
                                            :required="false"/>
                                    </div>
                                </div>
                                <div class="col-12 col-md-3">
                                    <label for="wdw_2">
                                        {{ $t('draw') }}
                                    </label>
                                    <div>
                                        <input
                                            type="number" 
                                            step="any"
                                            id="wdw_2"
                                            name="wdw[2]"
                                            v-model="selectedConditions['wdw']['2']"
                                            class="form-control"
                                            :placeholder="$t('min_odds')"
                                            :required="false"/>
                                    </div>
                                </div>
                                <div class="col-12 col-md-3">
                                    <label for="wdw_3">
                                        {{ $t('away') }}
                                    </label>
                                    <div>
                                        <input
                                            type="number" 
                                            step="any"
                                            id="wdw_3"
                                            name="wdw[3]"
                                            v-model="selectedConditions['wdw']['3']"
                                            class="form-control"
                                            :placeholder="$t('min_odds')"
                                            :required="false"/>
                                    </div>
                                </div>
                                <div class="col-12 col-md-3">
                                    <label for="wdw_s">
                                        {{ $t('stake') }}
                                    </label>
                                    <div>
                                        <input
                                            type="number" 
                                            step="any"
                                            id="wdw_s"
                                            name="wdw[s]"
                                            v-model="selectedConditions['wdw']['s']"
                                            class="form-control"
                                            :placeholder="$t('min_stake')"
                                            :required="false"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="pt-4">
                            <div class="d-flex justify-content-center pb-2">{{ $t('asian_handicap') }}</div>
                            <div class="d-flex flex-column flex-md-row">
                                <div class="col-12 col-md-3">
                                    <label for="ah_1">
                                        {{ $t('line') }}
                                    </label>
                                    <div>
                                        <input
                                            type="number" 
                                            step="any"
                                            id="ah_1"
                                            name="ah[1]"
                                            v-model="selectedConditions['ah']['1']"
                                            class="form-control"
                                            :placeholder="$t('min_line')"
                                            :required="false"/>
                                    </div>
                                </div>
                                <div class="col-12 col-md-3">
                                    <label for="ah_2">
                                        {{ $t('home') }}
                                    </label>
                                    <div>
                                        <input
                                            type="number" 
                                            step="any"
                                            id="ah_2"
                                            name="ah[2]"
                                            v-model="selectedConditions['ah']['2']"
                                            class="form-control"
                                            :placeholder="$t('min_odds')"
                                            :required="false"/>
                                    </div>
                                </div>
                                <div class="col-12 col-md-3">
                                    <label for="ah_3">
                                        {{ $t('away') }}
                                    </label>
                                    <div>
                                        <input
                                            type="number" 
                                            step="any"
                                            id="ah_3"
                                            name="ah[3]"
                                            v-model="selectedConditions['ah']['3']"
                                            class="form-control"
                                            :placeholder="$t('min_odds')"
                                            :required="false"/>
                                    </div>
                                </div>
                                <div class="col-12 col-md-3">
                                    <label for="ah_s">
                                        {{ $t('stake') }}
                                    </label>
                                    <div>
                                        <input
                                            type="number" 
                                            step="any"
                                            id="ah_s"
                                            name="ah[s]"
                                            v-model="selectedConditions['ah']['s']"
                                            class="form-control"
                                            :placeholder="$t('min_stake')"
                                            :required="false"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="pt-4">
                            <div class="d-flex justify-content-center pb-2">{{ $t('over_under') }}</div>
                            <div class="d-flex flex-column flex-md-row">
                                <div class="col-12 col-md-3">
                                    <label for="ou_1">
                                        {{ $t('line') }}
                                    </label>
                                    <div>
                                        <input
                                            type="number" 
                                            step="any"
                                            id="ou_1"
                                            name="ou[1]"
                                            v-model="selectedConditions['ou']['1']"
                                            class="form-control"
                                            :placeholder="$t('min_line')"
                                            :required="false"/>
                                    </div>
                                </div>
                                <div class="col-12 col-md-3">
                                    <label for="ou_2">
                                        {{ $t('over') }}
                                    </label>
                                    <div>
                                        <input
                                            type="number" 
                                            step="any"
                                            id="ou_2"
                                            name="ou[2]"
                                            v-model="selectedConditions['ou']['2']"
                                            class="form-control"
                                            :placeholder="$t('min_odds')"
                                            :required="false"/>
                                    </div>
                                </div>
                                <div class="col-12 col-md-3">
                                    <label for="ou_3">
                                        {{ $t('under') }}
                                    </label>
                                    <div>
                                        <input
                                            type="number" 
                                            step="any"
                                            id="ou_3"
                                            name="ou[3]"
                                            v-model="selectedConditions['ou']['3']"
                                            class="form-control"
                                            :placeholder="$t('min_odds')"
                                            :required="false"/>
                                    </div>
                                </div>
                                <div class="col-12 col-md-3">
                                    <label for="ou_s">
                                        {{ $t('stake') }}
                                    </label>
                                    <div>
                                        <input
                                            type="number" 
                                            step="any"
                                            id="ou_s"
                                            name="ou[s]"
                                            v-model="selectedConditions['ou']['s']"
                                            class="form-control"
                                            :placeholder="$t('min_stake')"
                                            :required="false"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </template>
                <template slot="footer">
                    <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal" @click="closeModal">
                        {{ $t('close') }}
                    </button>
                    <button v-if="selectedRow.game_notifications == null" type="button" class="btn btn-primary" data-dismiss="modal" @click="saveCreateAlert">{{ $t('create_notification') }}</button>
                    
                    <button v-if="selectedRow.game_notifications != null" type="button" class="btn btn-danger mr-2" data-dismiss="modal" @click="deleteAlert">{{ $t('delete_notification') }}</button>
                    <button v-if="selectedRow.game_notifications != null" type="button" class="btn btn-primary" data-dismiss="modal" @click="saveCreateAlert">{{ $t('update_notification') }}</button>
                </template>
            </app-modal>
            <app-modal v-if="confirmedModal"
                        modal-id="confirm-modal"
                        modal-alignment="center"
                        modal-size="md"
                        @close-modal="closeModal">
                <div class="modal-body d-flex flex-column justify-content-center modal-alert">
                    <div class="text-center">
                        <app-icon class="text-success text-center" :name="'check-circle'"/>
                    </div>
                    <h5 class="text-center font-weight-bold mt-4">{{ $t('congratulation') }}</h5>
                    <p class="text-center mb-primary p-0 font-size-90">{{ $t('confirm_text') }}</p>
                    <div class="text-center">
                        <a href="#" class="btn btn-success" data-dismiss="modal" @click="closeModal">{{ $t('continue') }}</a>
                    </div>
                </div>
            </app-modal>
            <app-modal v-if="alertModal"
                        modal-id="alert-modal"
                        modal-alignment="center"
                        modal-size="md"
                        @close-modal="closeModal">
                <div class="modal-body d-flex flex-column justify-content-center modal-alert">
                    <div class="text-center">
                        <app-icon class="text-warning" :name="'alert-triangle'"/>
                    </div>
                    <h5 class="text-center font-weight-bold mt-4">{{ $t('alert')+'!' }}</h5>
                    <p class="text-center mb-primary p-0  font-size-90">{{ $t('something_went_wrong') }}</p>
                    <div class="text-center">
                        <a href="#" class="btn btn-warning" data-dismiss="modal" @click="closeModal">
                            {{ $t('continue') }}
                        </a>
                    </div>
                </div>
            </app-modal>
        </div>
    </div>
</template>

<script>

    import * as actions from "../../../../Config/ApiUrl";
    import CoreLibrary from "../../../../../core/helpers/CoreLibrary";
    import { FormMixin } from "../../../../../core/mixins/form/FormMixin.js";
    import {BETFAIR_GAME} from "../../../../Config/ApiUrl";

    export default {
        name: "betfair-sports-filter",
        mixins: [FormMixin],
        extends: CoreLibrary,
        props: ['sport'],
        data() {
            return {
                confirmedModal: false,
                alertModal: false,
                createAlertModal: false,
                selectedRow: null,
                selectedConditions: {
                    'wdw': {},
                    'ah': {},
                    'ou': {}
                },
                options: {
                    id: 'sports-table',
                    name: this.$t('sports_filter'),
                    url: actions.BETFAIR_DATATABLE_DATA,
                    showHeader: true,
                    showCount: true,
                    showClearFilter: true,
                    enableSaveFilter: true,
                    columns: [
                        {
                            title: 'ID',
                            type: 'custom-html',
                            key: 'id',
                            modifier: (value) => {
                                if (value != null){
                                    return '<a href="/' + actions.BETFAIR_GAME + '/' + value + '/" target="_blank">' + value + '</a>';
                                }
                                return '-';
                            }
                        },
                        {
                            title: this.$t('time'),
                            type: 'text',
                            key: 'open_date',
                    
                        },
                        {
                            title: this.$t('sport'),
                            type: 'custom-html',
                            key: 'sport',
                            modifier: (value) => {
                                let sport = value.toLowerCase();
                                let response = '<div class="py-1 px-2 d-flex align-items-center">';
                                if (sport == 'basketball') {
                                    response += '<img src="/images/sports/basketball.png" style="height: 15px; padding-right: 5px;">';
                                } else if (sport == 'tennis') {
                                    response += '<img src="/images/sports/tennis.png" style="height: 15px; padding-right: 5px;">';
                                } else if (sport == 'football') {
                                    response += '<img src="/images/sports/football.png" style="height: 15px; padding-right: 5px;">';
                                } else if (sport == 'soccer') {
                                    sport = 'football';
                                    response += '<img src="/images/sports/football.png" style="height: 15px; padding-right: 5px;">';
                                }
                                response += this.$t(sport);
                                response += '</div>';

                                return response;
                            }

                        },
                        {
                            title: this.$t('name'),
                            type: 'text',
                            key: 'name',
                    
                        },
                        /*{
                            title: 'Team 1',
                            type: 'text',
                            key: 'team1',
                    
                        },
                        {
                            title: 'Team 2',
                            type: 'text',
                            key: 'team2',
                    
                        },*/
                        {
                            title: this.$t('competition'),
                            type: 'text',
                            key: 'competition',
                    
                        },
                        {
                            title: this.$t('wdw'),
                            key: 'full_time',
                            type: 'custom-html',
                            modifier: (value, row) => {
                                if (value != null){
                                    let home_id = value.home_id;
                                    let away_id = value.away_id;
                                    let draw_id = value.draw_id;

                                    let main_odds = row.full_time_main;
                                    let code = '';
                                    for (let index = 0; index < main_odds.length; ++index) {
                                        const element = main_odds[index];
                                        let margin = main_odds.length > 1 && index < 2 ? 'margin-bottom: 5px;' : '';
                                        let market = 'Unknown';

                                        if (element.selection_id == home_id){
                                            market = this.$t('home');
                                        } else if (element.selection_id == away_id){
                                            market = this.$t('away');
                                        } else if (element.selection_id == draw_id){
                                            market = this.$t('draw');
                                        }
                                        code += '<div class="d-flex justify-content-between"><div>' + market + '</div>';
                                        if (element.market_matched > 0) {
                                          code += '<div>[ ' + element.matched + ' / ' + element.market_matched + ' ]</div><div><b>[ ' + element.market_matched_percentage + '% ]</b></div>';
                                        } else {
                                          code += '<div style="color: #777;">[ 0 / 0 ]</div><div style="color: #777;"><b>[ 0% ]</b></div>';
                                        }
                                        code += '</div>';
                                        code += '<div class="bf-container" style="' + margin + '">';
                                        let available_to_back = JSON.parse(element.available_to_back);
                                        let available_to_lay = JSON.parse(element.available_to_lay);
                                        if (available_to_back.length > 2){
                                            code += ('<div class="back-3"><div class="price">' + available_to_back[2].price + '</div><div class="size">' + available_to_back[2].size + '</div></div>');
                                        } else {
                                            code += '<div class="back-3 empty">&nbsp;</div>';
                                        }
                                        if (available_to_back.length > 1){
                                            code += ('<div class="back-2"><div class="price">' + available_to_back[1].price + '</div><div class="size">' + available_to_back[1].size + '</div></div>');
                                        } else {
                                            code += '<div class="back-2 empty">&nbsp;</div>';
                                        }
                                        if (available_to_back.length > 0){
                                            code += ('<div class="back-1"><div class="price">' + available_to_back[0].price + '</div><div class="size">' + available_to_back[0].size + '</div></div>');
                                        } else {
                                            code += '<div class="back-1 empty">&nbsp;</div>';
                                        }
                                        if (available_to_lay.length > 0){
                                            code += ('<div class="lay-1"><div class="price">' + available_to_lay[0].price + '</div><div class="size">' + available_to_lay[0].size + '</div></div>');
                                        } else {
                                            code += '<div class="lay-1 empty">&nbsp;</div>';
                                        }
                                        if (available_to_lay.length > 1){
                                            code += ('<div class="lay-2"><div class="price">' + available_to_lay[1].price + '</div><div class="size">' + available_to_lay[1].size + '</div></div>');
                                        } else {
                                            code += '<div class="lay-2 empty">&nbsp;</div>';
                                        }
                                        if (available_to_lay.length > 2){
                                            code += ('<div class="lay-3"><div class="price">' + available_to_lay[2].price + '</div><div class="size">' + available_to_lay[2].size + '</div></div>');
                                        } else {
                                            code += '<div class="lay-3 empty">&nbsp;</div>';
                                        }
                                        code += '</div>';
                                    }
                                    return code;
                                }
                            }
                    
                        },
                        {
                            title: this.$t('asian_handicap'),
                            key: 'asian_handicap',
                            type: 'custom-html',
                            modifier: (value, row) => {
                                if (value != null){
                                    let home_id = value.home_id;
                                    let away_id = value.away_id;

                                    let main_odds = row.asian_handicap_main;
                                    let code = '';
                                    for (let index = 0; index < main_odds.length; ++index) {
                                        const element = main_odds[index];
                                        let margin = main_odds.length > 1 && index < 2 ? 'margin-bottom: 5px;' : '';
                                        let market = 'Unknown';

                                        if (element.selection_id == home_id){
                                            market = this.$t('home') + ' ' + element.handicap;
                                        } else if (element.selection_id == away_id){
                                            market = this.$t('away') + ' ' + element.handicap;
                                        }

                                        code += '<div class="d-flex justify-content-between"><div>' + market + '</div>';
                                        if (element.market_matched > 0) {
                                          code += '<div>[ ' + element.matched + ' / ' + element.market_matched + ' ]</div><div><b>[ ' + element.market_matched_percentage + '% ]</b></div>';
                                        } else {
                                          code += '<div style="color: #777;">[ 0 / 0 ]</div><div style="color: #777;"><b>[ 0% ]</b></div>';
                                        }
                                        code += '</div>';
                                        code += '<div class="bf-container" style="' + margin + '">';
                                        let available_to_back = JSON.parse(element.available_to_back);
                                        let available_to_lay = JSON.parse(element.available_to_lay);
                                        if (available_to_back.length > 2){
                                            code += ('<div class="back-3"><div class="price">' + available_to_back[2].price + '</div><div class="size">' + available_to_back[2].size + '</div></div>');
                                        } else {
                                            code += '<div class="back-3 empty">&nbsp;</div>';
                                        }
                                        if (available_to_back.length > 1){
                                            code += ('<div class="back-2"><div class="price">' + available_to_back[1].price + '</div><div class="size">' + available_to_back[1].size + '</div></div>');
                                        } else {
                                            code += '<div class="back-2 empty">&nbsp;</div>';
                                        }
                                        if (available_to_back.length > 0){
                                            code += ('<div class="back-1"><div class="price">' + available_to_back[0].price + '</div><div class="size">' + available_to_back[0].size + '</div></div>');
                                        } else {
                                            code += '<div class="back-1 empty">&nbsp;</div>';
                                        }
                                        if (available_to_lay.length > 0){
                                            code += ('<div class="lay-1"><div class="price">' + available_to_lay[0].price + '</div><div class="size">' + available_to_lay[0].size + '</div></div>');
                                        } else {
                                            code += '<div class="lay-1 empty">&nbsp;</div>';
                                        }
                                        if (available_to_lay.length > 1){
                                            code += ('<div class="lay-2"><div class="price">' + available_to_lay[1].price + '</div><div class="size">' + available_to_lay[1].size + '</div></div>');
                                        } else {
                                            code += '<div class="lay-2 empty">&nbsp;</div>';
                                        }
                                        if (available_to_lay.length > 2){
                                            code += ('<div class="lay-3"><div class="price">' + available_to_lay[2].price + '</div><div class="size">' + available_to_lay[2].size + '</div></div>');
                                        } else {
                                            code += '<div class="lay-3 empty">&nbsp;</div>';
                                        }
                                        code += '</div>';
                                    }
                                    return code;
                                }
                            }
                    
                        },
                        /*{
                            title: 'Asian handicap',
                            type: 'expandable-column',
                            key: 'name',
                            className: 'success', // Should be warning, success, primary, danger, dark, light, secondary
                            isVisible: true, // not required
                            componentName: 'expandable-view',
                            showTitle: 'Show', // not required. if not given, must send in modifier
                            hideTitle: 'Hide', // not required. if not given, must send in modifier
                            showIcon: 'eye', // not required
                            hideIcon: 'eye-off', // not required
                            modifier: (value, row) => {
                                let returnObj = {};
                                returnObj.prefixData = 12; // not required // default false
                                returnObj.title = 'expand'; // Button Title
                                returnObj.expandable = true; // Expandable and Component render (default true)
                                //returnObj.button = true; // Clickable Button  (Default false and show badges)
                                returnObj.visible = true; // Column visibility (Default true)
                                return returnObj;
                            }
                    
                        },*/
                        {
                            title: this.$t('over_under'),
                            key: 'over_under',
                            type: 'custom-html',
                            modifier: (value, row) => {
                                if (value != null){
                                    let over_ids = [];
                                    let under_ids = [];

                                    for (let index = 0; index < value.length; ++index) {
                                        const element = value[index];
                                        let over_id = parseInt(element.over_id);
                                        let under_id = parseInt(element.under_id);
                                        if (!over_ids.includes(over_id)){
                                            over_ids.push(over_id);
                                        }
                                        if (!under_ids.includes(under_id)){
                                            under_ids.push(under_id);
                                        }
                                    }

                                    let main_odds = row.over_under_main;
                                    let code = '';
                                    for (let index = 0; index < main_odds.length; ++index) {
                                        const element = main_odds[index];
                                        let margin = main_odds.length > 1 && index < 2 ? 'margin-bottom: 5px;' : '';
                                        let market = 'Unknown';

                                        if (over_ids.includes(parseInt(element.selection_id))){
                                            market = this.$t('over') + ' ' + element.line;
                                        } else if (under_ids.includes(parseInt(element.selection_id))){
                                            market = this.$t('under') + ' ' + element.line;
                                        }

                                        code += '<div class="d-flex justify-content-between"><div>' + market + '</div>';
                                        if (element.market_matched > 0) {
                                          code += '<div>[ ' + element.matched + ' / ' + element.market_matched + ' ]</div><div><b>[ ' + element.market_matched_percentage + '% ]</b></div>';
                                        } else {
                                          code += '<div style="color: #777;">[ 0 / 0 ]</div><div style="color: #777;"><b>[ 0% ]</b></div>';
                                        }
                                        code += '</div>';
                                        code += '<div class="bf-container" style="' + margin + '">';
                                        let available_to_back = JSON.parse(element.available_to_back);
                                        let available_to_lay = JSON.parse(element.available_to_lay);
                                        if (available_to_back.length > 2){
                                            code += ('<div class="back-3"><div class="price">' + available_to_back[2].price + '</div><div class="size">' + available_to_back[2].size + '</div></div>');
                                        } else {
                                            code += '<div class="back-3 empty">&nbsp;</div>';
                                        }
                                        if (available_to_back.length > 1){
                                            code += ('<div class="back-2"><div class="price">' + available_to_back[1].price + '</div><div class="size">' + available_to_back[1].size + '</div></div>');
                                        } else {
                                            code += '<div class="back-2 empty">&nbsp;</div>';
                                        }
                                        if (available_to_back.length > 0){
                                            code += ('<div class="back-1"><div class="price">' + available_to_back[0].price + '</div><div class="size">' + available_to_back[0].size + '</div></div>');
                                        } else {
                                            code += '<div class="back-1 empty">&nbsp;</div>';
                                        }
                                        if (available_to_lay.length > 0){
                                            code += ('<div class="lay-1"><div class="price">' + available_to_lay[0].price + '</div><div class="size">' + available_to_lay[0].size + '</div></div>');
                                        } else {
                                            code += '<div class="lay-1 empty">&nbsp;</div>';
                                        }
                                        if (available_to_lay.length > 1){
                                            code += ('<div class="lay-2"><div class="price">' + available_to_lay[1].price + '</div><div class="size">' + available_to_lay[1].size + '</div></div>');
                                        } else {
                                            code += '<div class="lay-2 empty">&nbsp;</div>';
                                        }
                                        if (available_to_lay.length > 2){
                                            code += ('<div class="lay-3"><div class="price">' + available_to_lay[2].price + '</div><div class="size">' + available_to_lay[2].size + '</div></div>');
                                        } else {
                                            code += '<div class="lay-3 empty">&nbsp;</div>';
                                        }
                                        code += '</div>';
                                    }
                                    return code;
                                }
                            }
                    
                        },
                        {
                            title: this.$t('action'),
                            type: 'action',
                        },
                    ],
                    actions: [
                    ],
                    filters: [
                        {
                            "title": this.$t('start_date_range'),
                            "type": "range-picker",
                            "key": "start-time-range",
                            "option": ["today", "thisMonth", "last7Days", "nextYear"]
                        },
                        {
                            "title": this.$t('sport'),
                            "type": "checkbox",
                            "key": "sport",
                            "option": [
                                {id: 'football', value: this.$t('football')},
                                {id: 'basketball', value: this.$t('basketball')},
                                {id: 'tennis', value: this.$t('tennis')},
                            ],
                        },
                        {
                            "title": this.$t('wdw'),
                            "type": "odds-range-filter",
                            "key": "wdw",
                            "firstTitle": this.$t('home'),
                            "secondTitle": this.$t('draw'),
                            "thirdTitle": this.$t('away'),
                            "stakeTitle": this.$t('stake'),
                            "sign": ""
                        },
                        {
                            "title": this.$t('asian_handicap'),
                            "type": "odds-range-filter",
                            "key": "ah",
                            "firstTitle": this.$t('line'),
                            "secondTitle": this.$t('home'),
                            "thirdTitle": this.$t('away'),
                            "stakeTitle": this.$t('stake'),
                            "sign": ""
                        },
                        {
                            "title": this.$t('over_under'),
                            "type": "odds-range-filter",
                            "key": "total",
                            "firstTitle": this.$t('line'),
                            "secondTitle": this.$t('over'),
                            "thirdTitle": this.$t('under'),
                            "stakeTitle": this.$t('stake'),
                            "sign": ""
                        },
                        {
                            "title": this.$t('sort_by'),
                            "type": "checkbox",
                            "key": "sort_by",
                            "option": [
                                {id: 'id', value: this.$t('ID')},
                                {id: 'date', value: this.$t('start_time')},
                                {id: 'wdw_1', value: this.$t('wdw_home')},
                                {id: 'wdw_2', value: this.$t('wdw_draw')},
                                {id: 'wdw_3', value: this.$t('wdw_away')},
                                {id: 'wdw_s', value: this.$t('wdw_stake')},
                                {id: 'ah_1', value: this.$t('ah_line')},
                                {id: 'ah_2', value: this.$t('ah_home')},
                                {id: 'ah_3', value: this.$t('ah_away')},
                                {id: 'ah_s', value: this.$t('ah_stake')},
                                {id: 'ou_1', value: this.$t('ou_line')},
                                {id: 'ou_2', value: this.$t('ou_over')},
                                {id: 'ou_3', value: this.$t('ou_under')},
                                {id: 'ou_s', value: this.$t('ou_stake')},
                                {id: 'odds_added', value: this.$t('odds_added_time')},
                                {id: 'wdw_added', value: this.$t('wdw_added_time')},
                                {id: 'ah_added', value: this.$t('ah_added_time')},
                                {id: 'ou_added', value: this.$t('ou_added_time')},
                                {id: 'odds_changed', value: this.$t('odds_changed_time')},
                                {id: 'wdw_changed', value: this.$t('wdw_changed_time')},
                                {id: 'ah_changed', value: this.$t('ah_changed_time')},
                                {id: 'ou_changed', value: this.$t('ou_changed_time')},
                                {id: 'stake_changed', value: this.$t('stake_changed')},
                                {id: 'wdw_stake_changed', value: this.$t('wdw_stake_changed')},
                                {id: 'ah_stake_changed', value: this.$t('ah_stake_changed')},
                                {id: 'ou_stake_changed', value: this.$t('ou_stake_changed')},
                            ],
                        },
                        {
                            "title": this.$t('order_asc_desc'),
                            "type": "checkbox",
                            "key": "order",
                            "option": [
                                {id: 'asc', value: 'ASC'},
                                {id: 'desc', value: 'DESC'},
                            ],
                        },
                    ],
                    paginationType: "pagination",
                    responsive: true,
                    rowLimit: 50,
                    showAction: true,
                    actionType: "default",
                    autoRefresh: true,
                    paginationOptions: [10, 25, 50, 100, 200],
                },
                actions: [
                {
                    "title": this.$t('favourite'),
                },
                {
                    "title": this.$t('alerts'),
                }
            ]
            }
        },
        created() {
            this.searchAndSelectFilterOptions();
        },
        methods: {
            getAction(row, actionObj, active) {
                if (actionObj.title == this.$t('favourite')) {
                    this.axiosGet(actions.GAME_FAVOURITE, {
                        params: {
                            id: row.id
                        }
                    }).then(response => {
                        if (response.data == 1){
                            row.favourites = {'game_id': row.id};
                            this.$toastr.s("<b>" + row.name + "</b><br/>" + this.$t('added_to_favourites'));
                        } else if (response.data == 0){
                            row.favourites = null;
                            this.$toastr.w("<b>" + row.name + "</b><br/>" + this.$t('removed_from_favourites'));
                        } else {
                            this.$toastr.e(this.$t('something_went_wrong'));
                        }
                    });
                } else if (actionObj.title == this.$t('alerts')) {
                    var gamerow = $('#game' + row.id);
                    this.selectedRow = row;
                    if (row.game_notifications != null && row.game_notifications.conditions != null){
                        this.selectedConditions = JSON.parse(row.game_notifications.conditions);
                    } else {
                        this.selectedConditions = {
                            'wdw': {},
                            'ah': {},
                            'ou': {}
                        };
                    }
                    if (row.game_notifications == null && gamerow.hasClass('game-notifications-row')){
                        this.$toastr.e(this.$t('system_is_still_syncing'));
                    } else if (row.game_notifications != null && !gamerow.hasClass('game-notifications-row')){
                        this.$toastr.e(this.$t('system_is_still_syncing'));
                    } else {
                        this.createAlertModal = true;
                    }
                }
            },
            closeModal() {
                this.createAlertModal = false;
                this.confirmedModal = false;
                this.alertModal = false;
            },
            deleteAlert() {
                var formData = new FormData();
                var gamerow = $('#game' + this.selectedRow.id);
                formData.append('game_id', this.selectedRow.id);
                this.createAlertModal = false;
                this.axiosPost({
                    url: actions.GAME_NOTIFICATION_DELETE,
                    data: formData,
                }).then(response => {
                    if (response.data == 1){
                        this.$toastr.w(this.$t('notification_deleted') + "<br/><b>" + this.selectedRow.name + "</b>");
                        if (gamerow){
                            gamerow.removeClass('game-notifications-row');
                        }
                    } else {
                        this.alertModal = true;
                    }
                });
            },
            saveCreateAlert() {
                var form = $("#create-alert");
                var formData = new FormData();
                var conditions = {};
                var gamerow = $('#game' + this.selectedRow.id);
                formData.append('game_id', this.selectedRow.id);
                conditions['wdw'] = {
                    '1': parseFloat(form.find('input[name="wdw[1]"]').val()),
                    '2': parseFloat(form.find('input[name="wdw[2]"]').val()),
                    '3': parseFloat(form.find('input[name="wdw[3]"]').val()),
                    's': parseFloat(form.find('input[name="wdw[s]"]').val()),
                };
                conditions['ah'] = {
                    '1': parseFloat(form.find('input[name="ah[1]"]').val()),
                    '2': parseFloat(form.find('input[name="ah[2]"]').val()),
                    '3': parseFloat(form.find('input[name="ah[3]"]').val()),
                    's': parseFloat(form.find('input[name="ah[s]"]').val()),
                };
                conditions['ou'] = {
                    '1': parseFloat(form.find('input[name="ou[1]"]').val()),
                    '2': parseFloat(form.find('input[name="ou[2]"]').val()),
                    '3': parseFloat(form.find('input[name="ou[3]"]').val()),
                    's': parseFloat(form.find('input[name="ou[s]"]').val()),
                };
                formData.append('conditions', JSON.stringify(conditions));
                this.createAlertModal = false;
                this.axiosPost({
                    url: actions.GAME_NOTIFICATION_ADD,
                    data: formData,
                }).then(response => {
                    if (response.data == 1){
                        this.$toastr.s(this.$t('notification_created') + "<br/><b>" + this.selectedRow.name + "</b>");
                        if (gamerow){
                            gamerow.addClass('game-notifications-row');
                        }
                    } else if (response.data == 2){
                        this.$toastr.s(this.$t('notification_updated') + "<br/><b>" + this.selectedRow.name + "</b>");
                    } else {
                        this.alertModal = true;
                    }
                });
            },
            searchAndSelectFilterOptions() {
                const params = new Proxy(new URLSearchParams(window.location.search), {
                    get: (searchParams, prop) => searchParams.get(prop),
                });
                this.axiosGet(actions.BETFAIR_DATATABLE_SEARCH, {
                    params: {
                        sport: this.sport == 'all' ? null : this.sport
                    }
                }).then(response => {
                    this.options.filters.push({
                        "title": this.$t('search_leagues'),
                        "type": "drop-down-filter",
                        "key": "league",
                        "option": [] = response.data.map(league => {
                            return {
                                id: league.id,
                                value: league.name
                            }
                        })
                    })
                });
            }
        }
    }
</script>
<style>
.bf-container {
    display: flex;
    text-align: center;
    color: #ececec;
}

.bf-container > div {
    flex: 1;
}

.back-1, .back-2, .back-3, .lay-1, .lay-2, .lay-3 {
    min-width: 80px;
}

.bf-container .price {
    font-weight: 600;
}

.back-1 {
    background: #559d63;
}

.back-1.empty {
    background: #3e724f;
}

.back-2 {
    background: #4b8558;
}

.back-2.empty {
    background: #39644a;
}

.back-3 {
    background: #416d4e;
}

.back-3.empty {
    background: #355645;
}

.lay-1 {
    background: #9d5555;
}

.lay-1.empty {
    background: #704045;
}

.lay-2 {
    background: #854b4b;
}

.lay-2.empty {
    background: #623b40;
}

.lay-3 {
    background: #6d4141;
}

.lay-3.empty {
    background: #54373c;
}

</style>